"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MangopayCreateTransferOptions = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
let MangopayCreateTransferOptions = class MangopayCreateTransferOptions {
};
exports.MangopayCreateTransferOptions = MangopayCreateTransferOptions;
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], MangopayCreateTransferOptions.prototype, "fee", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], MangopayCreateTransferOptions.prototype, "amount", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MangopayCreateTransferOptions.prototype, "fromMangoUserId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MangopayCreateTransferOptions.prototype, "fromWalletId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MangopayCreateTransferOptions.prototype, "toWalletId", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], MangopayCreateTransferOptions.prototype, "currency", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], MangopayCreateTransferOptions.prototype, "usableFromWalletAmountAfterTransfer", void 0);
exports.MangopayCreateTransferOptions = MangopayCreateTransferOptions = __decorate([
    (0, class_transformer_1.Exclude)()
], MangopayCreateTransferOptions);
//# sourceMappingURL=MangopayCreateTransferOptions.js.map